module.exports = __webpack_public_path__ + "media/images/bnr-set-sm-05c3df7234484e269835f65e7ff85b6b.png";